export const GET_TRIPS_PENDING = "GET_TRIPS_PENDING"
export const GET_TRIPS_SUCCESS = "GET_TRIPS_SUCCESS"
export const GET_TRIPS_FAILURE = "GET_TRIPS_FAILURE"

export const ADD_TRIPS_PENDING = "ADD_TRIPS_PENDING"
export const ADD_TRIPS_SUCCESS = "ADD_TRIPS_SUCCESS"
export const ADD_TRIPS_FAILURE = "ADD_TRIPS_FAILURE"

export const UPLOAD_TRIPS_PENDING = "UPLOAD_TRIPS_PENDING"
export const UPLOAD_TRIPS_SUCCESS = "UPLOAD_TRIPS_SUCCESS"
export const UPLOAD_TRIPS_FAILURE = "UPLOAD_TRIPS_FAILURE"

export const UPLOAD_RATES_PENDING = "UPLOAD_RATES_PENDING"
export const UPLOAD_RATES_SUCCESS = "UPLOAD_RATES_SUCCESS"
export const UPLOAD_RATES_FAILURE = "UPLOAD_RATES_FAILURE"

export const EDIT_TRIPS_PENDING = "EDIT_TRIPS_PENDING"
export const EDIT_TRIPS_SUCCESS = "EDIT_TRIPS_SUCCESS"
export const EDIT_TRIPS_FAILURE = "EDIT_TRIPS_FAILURE"

export const DELETE_TRIPS_PENDING = "DELETE_TRIPS_PENDING"
export const DELETE_TRIPS_SUCCESS = "DELETE_TRIPS_SUCCESS"
export const DELETE_TRIPS_FAILURE = "DELETE_TRIPS_FAILURE"

export const DOWNLOAD_TRIPS_PENDING = "DOWNLOAD_TRIPS_PENDING"
export const DOWNLOAD_TRIPS_SUCCESS = "DOWNLOAD_TRIPS_SUCCESS"
export const DOWNLOAD_TRIPS_FAILURE = "DOWNLOAD_TRIPS_FAILURE"
